export default __webpack_public_path__ + "static/media/bp5.52472251.jpg";